import { InputHTMLAttributes, useCallback } from 'react';

import { OrderSubmissionContactType } from 'api/types/entity';
import { useTranslation } from 'libs/i18n';
import {
  getPlaceholderByType,
  getTypes,
  useFormContext,
  Field,
  OrderSubmissionContactFormTypeOption,
} from 'modules/client/common/forms/orderSubmissionContactsForm';

import { GridFieldsStyled } from './Fields.styles';

interface Props {
  index: number;
}

export const Fields = ({ index }: Props) => {
  const { values, setValues } = useFormContext();
  const { t } = useTranslation();

  const valueIsPhone =
    values.orderSubmissionContacts[index].type?.value ===
      OrderSubmissionContactType.Phone ||
    values.orderSubmissionContacts[index].type?.value ===
      OrderSubmissionContactType.WhatsApp;
  const valueIsEmail =
    values.orderSubmissionContacts[index].type?.value ===
    OrderSubmissionContactType.Email;

  const ValueFieldComp = valueIsPhone ? Field.Phone : Field.Text;

  let valueFieldType: InputHTMLAttributes<unknown>['type'] = 'text';
  if (valueIsPhone) {
    valueFieldType = 'phone';
  } else if (valueIsEmail) {
    valueFieldType = 'email';
  }

  const onChangeType = useCallback(
    (value: object | object[] | null) => {
      setValues({
        ...values,
        orderSubmissionContacts: values.orderSubmissionContacts.map(
          (item, idx) => {
            if (idx === index) {
              return {
                ...item,
                type: value as OrderSubmissionContactFormTypeOption,
                value: '',
              };
            }
            return item;
          }
        ),
      });
    },
    [index, setValues, values]
  );

  return (
    <GridFieldsStyled>
      <Field.Autocomplete
        hideClearIcon
        showRequiredMark
        getOptionDisabled={(option) =>
          (option as OrderSubmissionContactFormTypeOption).value ===
          values.orderSubmissionContacts[index].type?.value
        }
        label={t('client.client.orderSubmissionContacts.contactTitle')}
        name={`orderSubmissionContacts.${index}.type`}
        optionLabelKey="label"
        options={getTypes(t)}
        optionValueKey="value"
        variant="select"
        onChange={onChangeType}
      />

      <ValueFieldComp
        fullWidth
        helperTextAbsolute
        showRequiredMark
        className="order-submission-contact-value-field"
        label={t('client.client.orderSubmissionContacts.contactLabel')}
        maxLength={valueIsPhone ? 22 : 200}
        name={`orderSubmissionContacts.${index}.value`}
        placeholder={getPlaceholderByType(
          t,
          values.orderSubmissionContacts[index].type.value
        )}
        type={valueFieldType}
      />
    </GridFieldsStyled>
  );
};
